<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name:'commodity',
    data(){
        return{

        }
    }
}
</script> 
<style scope lang="scss">
    
</style>